import { component } from 'picoapp'
import { toggle } from './toggle'

export default component((node, ctx) => {

  const openNavs = document.querySelectorAll('.js-open-nav');
  const closeNavs = document.querySelectorAll('.js-close-nav');
  const showSubnav = node.querySelectorAll('.js-toggle-subnav');
  const backSubnav = node.querySelectorAll('.js-back-subnav');
  const mobileMenu = document.querySelector('.mobile-menu');
  const menu = node;

  // toggle nav on any class of 'js-open-nav
  for (let i = 0; i < openNavs.length; i++) {
    const elem = openNavs[i];
    
    elem.addEventListener('click', function(evt) {
      evt.preventDefault();
      toggle(node);
    })
  }

  // toggle nav on any class of 'js-close-nav'
  for (let i = 0; i < closeNavs.length; i++) {
    const elem = closeNavs[i];
    
    elem.addEventListener('click', function(evt) {
      evt.preventDefault();
      toggle(node);
    })
  }

  for (let i = 0; i < showSubnav.length; i++) {
    const elem = showSubnav[i];
    const subnav = elem.nextElementSibling;
    
    elem.addEventListener('click', function(evt) {
      evt.preventDefault();
      toggle(subnav)
    })
  }
  
  for (let i = 0; i < backSubnav.length; i++) {
    const elem = backSubnav[i];
    const subnav = elem.closest('.subnav');
    
    elem.addEventListener('click', function(evt) {
      evt.preventDefault();
      toggle(subnav)
    })
  }

  // @todo: esc and click off need to close
  document.addEventListener('click', function(evt) {
    // console.log(evt.target);
    if (evt.target.classList.contains('js-open-nav')) return;
    if (menu.classList.contains('is-visible') && !menu.contains(evt.target)) {
      toggle(mobileMenu)
    }
  }, false);
})
